import { FormattedMessage } from '@alltrails/shared/react-intl';
import CustomProvider from 'components/CustomProvider';
import { getFormattedTrailUrls } from '../../../../utils/trail_helpers';

const createReactClass = require('create-react-class');

const BaseEditTrailEndBox = createReactClass({
  render() {
    const { trail, context } = this.props;
    let actionButton = null;
    if (trail.slug) {
      const { localizedUrl } = getFormattedTrailUrls(trail, context.languageRegionCode);
      actionButton = (
        <a href={localizedUrl} className="btn simple">
          <FormattedMessage defaultMessage="Return to trail" />
        </a>
      );
    }
    return (
      <div id="contribute-start" className="xlate-none">
        <div id="contribute-title">
          <span className="contribute-title-text">
            <h1>
              <FormattedMessage defaultMessage="Thanks for contributing!" />
            </h1>
          </span>
        </div>
        <div id="contribute-welcome">
          <div className="contribute-text">
            <FormattedMessage defaultMessage="Your changes will be reviewed and the trail updated as soon as they're approved." />
          </div>
        </div>
        <div id="contribute-action-bar">
          <a
            href={`${window.base_support_url}/articles/360018930672-How-do-I-update-or-change-information-about-a-trail-`}
            target="_blank"
            className="editor-help"
          >
            <FormattedMessage defaultMessage="Contribute help" />
          </a>
          <span className="buttons">{actionButton}</span>
        </div>
      </div>
    );
  }
});

const EditTrailEndBox = props => {
  return (
    <CustomProvider>
      <BaseEditTrailEndBox {...props} />
    </CustomProvider>
  );
};

export { EditTrailEndBox };
